import { render, staticRenderFns } from "./CostBreakdownMainTableModal.vue?vue&type=template&id=298b9bce&scoped=true&"
import script from "./CostBreakdownMainTableModal.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownMainTableModal.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownMainTableModal.vue?vue&type=style&index=0&id=298b9bce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b9bce",
  null
  
)

export default component.exports